<template>
    <div>
        <div class="toptitle">已派遣/未派遣</div>
        <div class="topcont">
            <div class="flex-between">
                <div>按月份 累计</div>
                <div class=" flex-between point" style="position: relative;">
                    <div @click="showDate = !showDate" class="flex datebox">
                        <div>{{ chooseDate.year }}-{{ chooseDate.mouth }}</div>
                        <i class="el-icon-caret-bottom"></i>
                    </div>
                    <div v-show="showDate" class="datechoosebox">
                        <div class="flex-center">
                            <i @click="prevYear" class="el-icon-d-arrow-left point"></i>
                            <div class="cutyear">{{ chooseDate.year }}</div>
                            <i @click="nextYear" class="el-icon-d-arrow-right point"></i>
                        </div>
                        <div class="flex" style="flex-wrap: wrap;">
                            <div @click="cliMouth(index)" class="mouthone" v-for="(item, index) in mouthList"
                                :key="index">{{ item }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 两个box -->
            <div class="flex-around" style="margin-top: 60px;">
                <div @click="showPqList(2)" class="paiqianone flex-column-center point">
                    <div class="pnum">{{ paiqianNum.dispatched || 0 }}</div>
                    <div class="ptext">已派遣</div>
                </div>
                <div @click="showPqList(1)" class="paiqianone flex-column-center point">
                    <div class="paiqianone flex-column-center point">
                        <div class="pnum">{{ paiqianNum.not_dispatched || 0 }}</div>
                        <div class="ptext">未派遣</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 弹窗 -->
        <el-dialog :visible.sync="pqListShow" append-to-body :show-close="false" custom-class="dialogbox">

            <div class="dialogdiv">
                <i class="el-icon-circle-close closeicon" @click="pqListShow = false"></i>
                <div class="dtoptit">{{ paiqianType == 2 ? '已派遣' : '未派遣' }}</div>
                <div class="dtitline"></div>
                <div class="flex-between" style="margin: 20px;">
                    <div>{{ chooseDate.year }}-{{ chooseDate.mouth }}</div>
                    <div>共{{ paiqianType == 2 ? paiqianNum.dispatched : paiqianNum.not_dispatched }}人</div>
                    <el-input v-model="search" placeholder="输入姓名/手机号/公司单位名称"></el-input>
                    <el-button @click="searchHandler" type="primary">查询</el-button>
                    <el-button @click="reset" plain>重置</el-button>
                </div>

                <!-- 已派遣列表 -->
                <div class="listbox" v-if="paiqianType == 2">
                    <div v-for="item in paiqianList" :key="item.id" class="flex-between listone">
                        <div class="flex">
                            <img :src="item.avatar" class="avatar" alt="">
                            <div class="name">{{ item.username }}</div>
                            <div>{{ item.mobile }}</div>
                        </div>
                        <div>{{ item.employer_title }}</div>
                    </div>

                </div>
                <!-- 未派遣列表 -->
                <div v-if="paiqianType == 1">
                    <div class="wlistbox">
                        <div v-for="item in paiqianList" :key="item.id" class="flex wlione">
                            <img :src="item.avatar" class="avatar" alt="">
                            <div class="name">{{ item.username }}</div>
                            <div>{{ item.mobile }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="!paiqianList.length">
                    <empty></empty>
                </div>

                <div class="flex-center" style="margin-top: 10px;">
                    <el-pagination layout="prev, pager, next,jumper" @current-change="getPaiqianList" :total="total"
                        background>
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import empty from "@/components/empty/empty.vue"

export default {
    components: {
        empty
    },
    data() {
        return {
            paiqianNum: {
                dispatched: 0,
                not_dispatched: 0
            },
            paiqianType: 2,
            search: '',
            paiqianList: [],
            pqListShow: false,
            showDate: false,
            mouthList: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            xianshiYear: new Date().getFullYear(),
            chooseDate: {
                year: new Date().getFullYear(),
                mouth: new Date().getMonth() + 1
            },
            page: 1,
            total: 0
        }
    },
    mounted() {
        this.getPaiqianNumber()
    },
    methods: {
        searchHandler() {
            this.page = 1
            this.getPaiqianList()
        },
        reset() {
            this.page = 1
            this.search = ''
            this.getPaiqianList()
        },
        // 获取弹窗数据
        getPaiqianList() {
            let data = {
                time: `${this.chooseDate.year}-${this.chooseDate.mouth}`,
                dispatch_status: this.paiqianType,
                page: this.page,
                pagesize: this.paiqianType == 2 ? 8 : 24,
                search: this.search
            }
            this.$api({
                url: '/api/central_control/dispatch_list',
                method: 'POST',
                data
            }).then(res => {
                console.log(res.data)
                this.total = res.data.total
                this.paiqianList = res.data.data
            })
        },
        // 已派遣 未派遣
        getPaiqianNumber() {
            this.$api({
                url: `/api/central_control/dispatch`,
                data: {
                    time: `${this.chooseDate.year}-${this.chooseDate.mouth}`
                },
                method: 'POST'
            }).then(res => {
                // console.log(res.data, "resresrs")
                this.paiqianNum = res.data
            })
        },
        showPqList(num) {
            this.paiqianType = num
            this.page = 1
            this.search = ''
            this.getPaiqianList()
            this.pqListShow = true

        },
        cliMouth(index) {
            let a = index + 1
            this.chooseDate.mouth = a < 10 ? '0' + a : a
            this.getPaiqianNumber()
            this.showDate = false
        },
        prevYear() {
            this.chooseDate.year = --this.chooseDate.year
            this.getPaiqianNumber()

        },
        nextYear() {
            this.chooseDate.year = ++this.chooseDate.year
            this.getPaiqianNumber()

        },
    }
}
</script>
<style scoped>
/deep/ .el-input__inner {
    background: #0F2B67 !important;
    border: 0;
}

/deep/.el-dialog__body {
    padding: 0;
    background: #0D2252 !important;
    border-radius: 25px;

}

/deep/ .dialogbox {
    background: #0D2252 !important;
    padding: 0;
    border-radius: 25px;
}

/deep/ .el-button {
    width: 82px;
}

/deep/ .el-button--primary {
    background: #1968FF;
    border-color: #1968FF;
}

/deep/ .is-plain {
    background: #0D2252;
    border: 1px solid #1968FF;
    color: #1968FF;
}
</style>
<style lang="less" scoped>
::v-deep {
    .el-dialog__header {
        padding: 0;
    }

    .el-input {
        width: 500px;
    }

    .el-input__inner {
        background: #0F2B67 !important;
        color: #fff !important;

    }

    .number {
        background: transparent !important;
    }

    .active {
        background: #16367B !important;
    }

    .btn-prev {
        background: transparent !important;
    }

    .btn-next {
        background: transparent !important;
    }
}

.wlistbox {
    display: flex;
    flex-wrap: wrap;
    padding: 0 20px;

    .wlione {
        margin-left: 45px;
        padding: 14px 16px;
        font-weight: 400;
        font-size: 13px;
        color: #EEEEEE;
        border-radius: 5px;

        &:nth-child(6n+4) {
            background: #082667;

        }

        &:nth-child(6n+5) {
            background: #082667;

        }

        &:nth-child(6n+6) {
            background: #082667;

        }
    }

}

.avatar {
    width: 27px;
    min-width: 27px;
    height: 27px;
    border-radius: 50%;
    margin-right: 16px;
}

.name {
    margin-right: 30px;
}

.listone {
    // margin-bottom: 20px;
    padding: 16px 10px;
    font-weight: 400;
    font-size: 13px;
    color: #EEEEEE;
    border-radius: 5px;



    &:nth-child(2n+2) {
        background: #082667;
    }

}



.dialogdiv {
    padding: 0 25px 25px;
    color: #fff;
    background: #0D2252;
    border-radius: 25px;
    position: relative;

    .closeicon {
        position: absolute;
        top: 12px;
        right: 12px;
        display: inline-block;
        font-size: 30px;
    }

    .dtoptit {
        background: url('@/assets/diatitbg.png') no-repeat 0 0/100% 100%;
        width: 244px;
        height: 53px;
        line-height: 53px;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
    }

    .dtitline {
        width: 100%;
        height: 2px;
        background: rgba(59, 110, 245, 0.3);
    }
}

.topcont {
    background: url('@/assets/conbg.png') no-repeat 0 0/100% 100%;
    width: 100%;
    // height: 100%;
    height: calc(((100vh - 100px) / 2) - 50px);
    // max-height: 385px;
    padding: 16px 26px;
    color: #fff;
    flex: 1;

}

.paiqianone {
    background: url("@/assets/paiqian.png") no-repeat 0 0 /100% 100%;
    width: 170px;
    height: 190px;

    .ptext {
        font-size: 20px;
        font-weight: 400;
        color: #ddd;
    }

    .pnum {
        font-size: 46px;
        font-weight: 700;
        margin-bottom: 5px;
    }
}

.datechoosebox {
    position: absolute;
    background: #041852;
    top: 33px;
    left: 0;
    // height: 33px;
    width: 400px;
    padding: 30px 0;
    box-sizing: border-box;

    .mouthone {
        font-size: 18px;
        margin: 20px;
        width: 80px;
        text-align: center;

        &:hover {
            background: #082667;
        }
    }

    .cutyear {
        margin: 0 30px;
        font-size: 20px;
        font-weight: 700;

    }

}
</style>
